import * as React from 'react'
import Error from '../components/Error'
import { ForbiddenIllustration } from '../components/Illustrations'
import type { Customization } from '../types/Customization'

type InvalidRedirectUriProps = {
  customization?: Customization
}

const defaultSolutionName = 'the solution owner'
const getText = ({ customization }: InvalidRedirectUriProps) => (
  <p>
    Configuration Error — Redirect URI is not valid.
    <br />
    Please contact{' '}
    {!!customization?.enrollmentHomeUrl && !!customization?.enrollmentTeamName ? (
      <a href={customization.enrollmentHomeUrl}>{customization.enrollmentTeamName}</a>
    ) : (
      defaultSolutionName
    )}{' '}
    for further information.
  </p>
)

const InvalidRedirectUri = ({ customization }: InvalidRedirectUriProps): JSX.Element => (
  <Error icon={<ForbiddenIllustration />} title="Invalid Redirect URL" text={getText({ customization })} />
)

export default InvalidRedirectUri
